package com.esoris.kmpmoout.modules

import com.esoris.kmpmoout.app.multiplatform_settings.AppSettings
import com.esoris.kmpmoout.navigation.navigationModule
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module

val appModule = module {

    // Multiplatform Settings (pengganti appDataStore)
    singleOf(::AppSettings)

}
    .plus(navigationModule)
  //  .plus(databaseModule) // specific di android dan desktop
    .plus(featuresModule)
    .plus(supabaseMainModule)